import { ReactElement, useState } from "react";

import DetailsTabs, { DetailTab } from "components/DetailsTabs";
import PrimaryButton from "components/PrimaryButton";
import ErrorLoading from "components/ErrorLoading";
import ContractTab from "./tabPanels/terms/ContractTab";
import OrdersTab from "./tabPanels/orders/OrdersTab";
import InvoicesTab from "./tabPanels/invoices/InvoicesTab";
import FilesTab from "./tabPanels/files/FilesTab";
import contractDetailsContractsFilters from "./tabPanels/filters/contract-details-contracts-filters";
import contractDetailsOrdersFilters from "./tabPanels/filters/contract-details-orders-filters";

enum CONTRACT_DETAIL_TAB_NAMES {
  Contract = "Contract",
  Orders = "Orders",
  Invoices = "Invoices",
  Files = "Files",
}

const contractDetailTabs: DetailTab<CONTRACT_DETAIL_TAB_NAMES>[] = [
  {
    tabName: CONTRACT_DETAIL_TAB_NAMES.Contract,
    component: ContractTab,
    tabHeading: "Contract",
    filters: contractDetailsContractsFilters,
  },
  {
    tabName: CONTRACT_DETAIL_TAB_NAMES.Orders,
    component: OrdersTab,
    tabHeading: "Orders",
    filters: contractDetailsOrdersFilters,
  },
  {
    tabName: CONTRACT_DETAIL_TAB_NAMES.Invoices,
    component: InvoicesTab,
    tabHeading: "Invoices",
    filters: [],
  },
  {
    tabName: CONTRACT_DETAIL_TAB_NAMES.Files,
    component: FilesTab,
    tabHeading: "Files",
    filters: [],
  },
];

const ContractDetailsTabs = (): ReactElement => {
  const [errorMessage, setErrorMessage] = useState<string>();
  if (errorMessage) {
    return (
      <ErrorLoading message={errorMessage}>
        <PrimaryButton
          colorScheme="yellow"
          onClick={() => setErrorMessage(undefined)}
        >
          Retry
        </PrimaryButton>
      </ErrorLoading>
    );
  }
  return (
    <DetailsTabs tabs={contractDetailTabs} setErrorMessage={setErrorMessage} />
  );
};

export default ContractDetailsTabs;
